export default __webpack_public_path__ + "static/media/failed_icon.b2978dd9.svg";